import { jsx } from 'react/jsx-runtime';
import { noop } from '@fabric-app/utils/guards/noop';
import { createLogger } from '@fabric-app/utils/logging';
import { useState, useCallback, useMemo, createContext, useContext } from 'react';

const defaultState = {
  contextId: null,
  resourceIds: [],
  setResourceIds: noop,
  fetchNextPage: noop,
  removeByResourceId: noop
};
const ResourceSwitcherContextState = /* @__PURE__ */ createContext(defaultState);
const logger = createLogger("resource-switcher");
const ResourcesSwitcherProvider = ({ children }) => {
  const [state, setState] = useState({
    resourceIds: [],
    fetchNextPage: noop,
    contextId: null
  });
  const setResourceIds = useCallback((resourceIds, options) => {
    setState((prev) => {
      if (options.ignoreIfContextIdDoesntMatch && prev.contextId !== options.contextId) {
        return prev;
      }
      logger.log("Set resource ids");
      return {
        ...prev,
        resourceIds,
        fetchNextPage: options?.fetchNextPage,
        contextId: options.contextId
      };
    });
  }, []);
  const removeByResourceId = useCallback((resourceId) => {
    logger.log("Remove id");
    setState((prev) => ({
      ...prev,
      resourceIds: prev.resourceIds.filter((id) => id !== resourceId)
    }));
  }, []);
  const value = useMemo(() => ({
    ...state,
    setResourceIds,
    removeByResourceId
  }), [
    state,
    setResourceIds,
    removeByResourceId
  ]);
  return /* @__PURE__ */ jsx(ResourceSwitcherContextState.Provider, {
    value,
    children
  });
};
const useResourceSwitcher = () => {
  const contextValue = useContext(ResourceSwitcherContextState);
  if (!contextValue) {
    throw new Error("useResourceSwitcher must be used within a ResourcesSwitcherProvider");
  }
  return contextValue;
};

export { ResourcesSwitcherProvider, useResourceSwitcher };
//# sourceMappingURL=resourcesSwitcher.js.map
